import { convertToDollars, formatAmountForDisplay } from '@/utils/paymentUtils';

/**
 * Prefactura (check) totals are stored in the organization currency.
 * For CRC venues, also show the USD equivalent using the org exchange rate.
 */
export function resolvePrefacturaDollarTotal(
  total: number,
  options: {
    forPreview: boolean;
    currency?: string;
    exchangeRate?: number;
  },
): number | undefined {
  if (!options.forPreview) return undefined;
  if (options.currency === 'USD') return undefined;
  if (!options.exchangeRate || options.exchangeRate <= 0) return undefined;
  if (!Number.isFinite(total) || total <= 0) return undefined;

  return formatAmountForDisplay(convertToDollars(total, options.exchangeRate), true);
}
